import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';

export default reducers => {
  const persistedReducer = persistReducer(
    {
      // TODO GET DOMAIN TO KEY.
      key: 'kloddy',
      storage,
      whitelist: ['config'],
    },
    reducers,
  );

  return persistedReducer;
};
